"use client";

import React, { useState } from "react";
import dynamic from "next/dynamic";
import { MotionSection } from "@/utils/clientMotion";
import Navbar from "@/components/navbar";
import ProductIntro from "./product-intro";
import ReBottBenefits from "./rebott-benefits";
import UsageSteps from "./usage-steps";
import ReBottBottleConditions from "./rebott-bottle-conditions";
import ReBottStats from "./rebott-stats";
import Partners from "./partners";
import Socialmedia from "./socialmedia";
import MapMarkers from "./map-markers";
import ContactUs from "./contact-us";
import ImgBannerInvite from "./img-banner-invite";
import Footer from "@/components/footer";

const UpcycledProducts = dynamic(() => import("./upcycled-products"), {
  ssr: false,
});

export default function Campaign() {
  const [activeHash, setActiveHash] = useState("");

  return (
    <div className="overflow-x-hidden">
      <Navbar onNavigate={setActiveHash} />

      <MotionSection
        id="product-intro"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: false, amount: 0.3 }}
      >
        <ProductIntro />
      </MotionSection>

      <MotionSection id="rebott-benefits">
        <ReBottBenefits />
      </MotionSection>

      <MotionSection
        id="usage-steps"
        initial={{ y: -100, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 12 }}
        viewport={{ once: false, amount: 0.4 }}
      >
        <UsageSteps />
      </MotionSection>

      <ReBottBottleConditions />

      <MotionSection id="stats">
        <ReBottStats />
      </MotionSection>

      <MotionSection key="upcycled-products" id="upcycled-products">
        <UpcycledProducts />
      </MotionSection>

      <MotionSection id="partners">
        {/* <Partners /> */}
      </MotionSection>

      <MotionSection id="contact-us">
        <ContactUs />
      </MotionSection>
      <Socialmedia />
      <MapMarkers />
      <ImgBannerInvite />

      <Footer />
    </div>
  );
}
